import { sendGAEvent } from '@noths/polaris-client-google-analytics';
import { EventsMap } from '@noths/polaris-client-next-redux';

import { ReduxApplicationState } from 'src/redux/combinedReducer';
import { getImpressionFieldObjects } from 'src/utils/googleAnalytics';
import { actions } from '../slice';
import { ProductImpressionsEvent } from './events';

export const GAEventsMap: EventsMap<ReduxApplicationState> = {
  [actions.setInitialPageLoad.type]: (prevState) => {
    sendGAEvent<ProductImpressionsEvent>({
      event: 'product_impressions',
      event_action: 'Product Impressions',
      event_category: 'Product listings',
      event_label: null,
      ecommerce: {
        impressions: getImpressionFieldObjects(prevState),
      },
    });
  },
};
